"use client";

import { SITE_SETTINGS_REVALIDATE_ENDPOINT } from "@/lib/siteSettingsCachePolicy";
import {
  SITE_SETTINGS_CHANNEL,
  createTabChannel,
  parseSiteSettingsMessage,
  type SiteSettingsMessage,
  type TabChannel,
} from "@/lib/tabChannel";

// Penyambung "admin baru saja menyimpan setelan toko" ke tiga tempat yang
// menyimpan salinan:
//   1. cache memori TAB INI — sudah dibuang penulisnya sendiri;
//   2. cache memori TAB LAIN di browser yang sama — siaran BroadcastChannel di
//      sini, supaya form setelan di tab kedua tak menampilkan nilai lama lalu
//      menimpanya saat disimpan;
//   3. cache `next.revalidate` SERVER (tema, banner, pixel, branding, template
//      WA) — route `POST /api/admin/revalidate-site-settings` membuang tag toko.
// Perangkat lain (pembeli) tetap bergantung pada TTL masing-masing.

const selfId =
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : String(Math.random()).slice(2);

let channel: TabChannel<SiteSettingsMessage> | null = null;
const invalidators = new Set<() => void>();

function getChannel() {
  if (!channel) {
    channel = createTabChannel<SiteSettingsMessage>(
      SITE_SETTINGS_CHANNEL,
      parseSiteSettingsMessage
    );
    channel.onMessage((msg) => {
      if (msg.from === selfId) return;
      for (const fn of [...invalidators]) fn();
    });
  }
  return channel;
}

/** Daftarkan pembuang cache memori sebuah modul klien. Aman dipanggil di server
 *  (tidak ada window → tidak membuka kanal). */
export function registerSettingsCacheInvalidator(fn: () => void): void {
  invalidators.add(fn);
  if (typeof window !== "undefined") getChannel();
}

/** Panggil SETELAH upsert `site_settings` berhasil. Best-effort: kegagalan di
 *  sini tak boleh membatalkan penyimpanan yang sudah sukses. */
export function notifySiteSettingsSaved(): void {
  if (typeof window === "undefined") return;
  getChannel().post({ t: "saved", from: selfId });
  void fetch(SITE_SETTINGS_REVALIDATE_ENDPOINT, {
    method: "POST",
    credentials: "same-origin",
    keepalive: true,
  }).catch(() => undefined);
}
